import { render, staticRenderFns } from "./DRSTList.vue?vue&type=template&id=7c55219a&"
import script from "./DRSTList.vue?vue&type=script&lang=ts&"
export * from "./DRSTList.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c55219a')) {
      api.createRecord('7c55219a', component.options)
    } else {
      api.reload('7c55219a', component.options)
    }
    module.hot.accept("./DRSTList.vue?vue&type=template&id=7c55219a&", function () {
      api.rerender('7c55219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTList.vue"
export default component.exports